import { render, staticRenderFns } from "./AdminActionsDropdown.vue?vue&type=template&id=4c893fe2&"
import script from "./AdminActionsDropdown.vue?vue&type=script&lang=js&"
export * from "./AdminActionsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports